import { create } from 'zustand';
import { authFetch } from '../services/auth';

export interface Me {
  userId: string;
  email: string;
  roles: string[];
  isAdmin: boolean;
}

interface MeState {
  me: Me | null;
  loaded: boolean;
  fetchMe: () => Promise<void>;
}

/** Current authenticated user + roles (from GET /api/admin/me), used to gate the admin UI. */
export const useMe = create<MeState>((set) => ({
  me: null,
  loaded: false,
  fetchMe: async () => {
    try {
      const res = await authFetch('/api/admin/me');
      if (res.ok) {
        set({ me: await res.json(), loaded: true });
      } else {
        set({ loaded: true });
      }
    } catch {
      set({ loaded: true });
    }
  },
}));
